export const PLAN_TYPE = {
  MONTHLY: 'monthly',
  YEARLY: 'yearly',
}

export const TIER = {
  ESSENTIALS: 'essentials',
  PREMIUM: 'premium',
  AI_STUDIO: 'ai_studio',
}

export const SUBSCRIPTION_STATUS = {
  // Backend statuses
  ACTIVE: 'active',
  CANCELED: 'canceled',
  EXPIRED: 'expired',
  PAST_DUE: 'past_due',
  PAUSED: 'paused',
  REDEMPTION: 'redemption',
  SUSPENDED: 'suspended',
  REJECTED: 'rejected',
  // Derived UI statuses
  FULLY_CANCELED: 'fully_canceled',
  PENDING_CANCEL: 'pending_cancel',
  PAUSE_SCHEDULED: 'pause_scheduled',
}

/**
 * Maps a backend status + canceledAt + userPauseScheduledAt into a UI display status.
 * - canceled → FULLY_CANCELED
 * - active + canceledAt → PENDING_CANCEL (user initiated cancellation, still has access)
 * - active + userPauseScheduledAt → PAUSE_SCHEDULED (pause requested, starts at period end)
 * - everything else → pass-through (includes the backend `paused` status)
 */
export function resolveDisplayStatus(status, canceledAt, userPauseScheduledAt = null) {
  if (status === SUBSCRIPTION_STATUS.CANCELED) return SUBSCRIPTION_STATUS.FULLY_CANCELED
  if (status === SUBSCRIPTION_STATUS.ACTIVE && canceledAt) return SUBSCRIPTION_STATUS.PENDING_CANCEL
  if (status === SUBSCRIPTION_STATUS.ACTIVE && userPauseScheduledAt) return SUBSCRIPTION_STATUS.PAUSE_SCHEDULED
  return status
}

// Maps the `error` code returned by pause/resume endpoints to a translation key under
// subscription_management.pause.errors. Unknown codes fall back to `generic`.
export const PAUSE_ERROR_KEYS = [
  'subscription_not_found',
  'subscription_cannot_be_paused',
  'subscription_pause_already_scheduled',
  'subscription_billing_period_unavailable',
  'subscription_pause_start_must_be_future',
  'user_pause_allowance_exhausted',
  'subscription_cannot_be_resumed',
  'solidgate_request_failed',
]
